export default "__VITE_ASSET__BClSIp3P__"